export default {
  'AEROSPACE_AND_DEFENSE': 'Aerospace & Defense',
  'AGRICULTURE_FORESTRY_AND_FISHING': 'Agriculture, Forestry & Fishing',
  'APPAREL_AND_FASHION': 'Apparel & Fashion',
  'ARTS_LEISURE_ENTERTAINMENT_AND_MEDIA': 'Arts, Leisure, Entertainment & Media',
  'AUTOMOTIVE': 'Automotive',
  'AVIATION_AND_TRANSPORTATION': 'Aviation & Transportation',
  'CHEMICALS_AND_SPECIALTY_MATERIALS': 'Chemicals & Specialty Materials',
  'CONSULTING_SERVICES': 'Consulting Services',
  'CONSUMER_PRODUCTS': 'Consumer Products',
  'COSMETICS': 'Cosmetics',
  'EDUCATIONAL_SERVICES': 'Educational Services',
  'ENERGY_OIL_AND_GAS': 'Energy, Oil & Gas',
  'ENGINEERING_AND_CONSTRUCTION_INDUSTRY': 'Engineering & Construction Industry',
  'ENVIRONMENTAL_SERVICES': 'Environmental Services',
  'FINANCIAL_SERVICES_AND_BANKING': 'Financial Services & Banking',
  'FOOD_AND_BEVERAGES': 'Food & Beverages',
  'GAMBLING': 'Gambling',
  'HEALTHCARE': 'Healthcare',
  'HOTELS_AND_ACCOMMODATION': 'Hotels & Accommodation',
  'INDUSTRIAL_PRODUCTS_AND_SERVICES': 'Industrial Products & Services',
  'INFORMATION_TECHNOLOGY_AND_IOT': '​Information Technology & IOT',
  'INSURANCE': 'Insurance',
  'INVESTMENT_MANAGEMENT': 'Investment Management',
  'LEGAL_SERVICES': 'Legal Services',
  'MANAGEMENT_OF_COMPANIES_AND_ENTERPRISES': 'Management of Companies & Enterprises',
  'MANUFACTURING': 'Manufacturing',
  'MINING_QUARRYING': 'Mining, Quarrying',
  'PHARMACEUTICALS': 'Pharmaceuticals',
  'POWER_AND_UTILITIES': 'Power & Utilities',
  'PUBLIC_RELATIONS_PR_AND_EVENTS': 'Public Relations, PR & Events',
  'PUBLIC_SECTOR_ADMINISTRATION_AND_GOVERNMENT': 'Public Sector, Administration & Government',
  'REAL_ESTATE_AND_PROPERTY_MANAGEMENT': 'Real Estate & Property Management',
  'RESEARCH_SERVICES': 'Research Services',
  'RESTAURANTS': 'Restaurants',
  'RETAIL_WHOLESALE_AND_DISTRIBUTION': 'Retail, Wholesale & Distribution',
  'SHIPPING_AND_PORTS': 'Shipping & Ports',
  'SPORTS': 'Sports',
  'STAFFING_AND_RECRUITING': 'Staffing & Recruiting',
  'TELECOMMUNICATIONS': 'Telecommunications',
  'TOBACCO': 'Tobacco',
  'WATER': 'Water',
  'OTHER': 'Other'
}
